import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='HIIT / Plyometrics' second='Workout 05' mt={true} />
			<RoundScreen
				title='Full Body 6 FOR 6 Power Workouts'
				isNumbered={false}
				rounds={[
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Star Jumps',
						},
						{
							header: 'REPS',
							value: '12',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Knee To Elbows',
						},
						{
							header: 'REPS',
							value: '12',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Woodchop w / (DB)',
						},
						{
							header: 'REPS',
							value: '12',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Shoulder Presses w / (DB)',
						},
						{
							header: 'REPS',
							value: '12',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Air  Squats w / (LB)',
						},
						{
							header: 'REPS',
							value: '12',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
